import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const StyledEmployeesCarouselTitle = styled(Typography)`
  font-family: 'Futura New Bold', serif;
  font-size: 1.1rem;
  color: #080606;
`;

export const StyledEmployeesCarouselText = styled(Typography)`
  font-family: 'Futura New Regular', serif;
  color: #080606;
`;
